import styled from "styled-components";
import { useState, useEffect } from "react";
import UserAndRulesLeftPane from "./UserAndRulesLeftPane";
import UserAndRulesRightPane from "./UserAndRulesRightPane";
import request from "../../../../api/request";
import { NotificationManager } from 'react-notifications';

const StyledUserAndRules = styled.div`
    display: flex;
`;

function UserAndRules(props) {

    const [loadedPage, setLoadedPage] = useState(false);
    const [users, setUsers] = useState([]);
    const [branches, setBranches] = useState([]);
    const [festivals, setFestivals] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Username', type: 'String', width: 130, textAlign: 'left'},
        {id: 'Central Office', type: 'Boolean', width: 110, textAlign: 'center'},
        {id: 'Logins', type: 'String', width: 60, textAlign: 'center'}
    ]);
    const [gridData, setGridData] = useState({groups: [''], items: [[]]});
    const [isAddMode, setIsAddMode] = useState(false);

    const onSelectGridItem = (item) => {
        props.setSmallPageTitle(item.Username);
        setSelectedUserId(item.Id);
        setSelectedUser(users[item.Id]);
    }

    const fetchUsers = async (userName) => {
        try {
            let users = [];
            let gridDataUsers = [];

            let resp = (await request('database', 'fetchUsers'));
            if (resp.ok) {
                resp.data.map((user, index) => {
                    users.push(user);
                    gridDataUsers.push({Id: index, Username: user.UserName, 'Central Office': user.IsCentralOffice, Logins: user.LoginCounter.toString()});

                    if (userName && user.UserName === userName) {
                        setSelectedUserId(index);
                        setSelectedUser(user);
                    }
                });
                setUsers(users);
                if (!userName) {
                    if (selectedUserId)
                        setSelectedUser(users[selectedUserId]);
                    else {
                        setSelectedUser(users[0]);
                        setSelectedUserId(0);
                    }
                }
                setGridData({groups: [''], items: [gridDataUsers]});
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
        } catch (e) {
            console.log('Failed to fetch users: ', e);
        }
    }

    const fetchBranches = async () => {
        try {
            let branches = [];
            let resp = (await request('database', 'fetchBranches'));
            if (resp.ok) {
                resp.data.map((branch) => {
                    branches.push(branch);
                });
                setBranches(branches);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
        } catch (e) {
            console.log('Failed to fetch branches: ', e);
        }
    }

    const fetchFestivals = async () => {
        try {
            let festivals = [];
            let resp = (await request('database', 'fetchFestivals'));
            if (resp.ok) {
                resp.data.map((festival) => {
                    festivals.push(festival);
                });
                setFestivals(festivals);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
        } catch (e) {
            console.log('Failed to fetch festivals: ', e);
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            props.setPageTitle('User');
            fetchUsers();
            fetchBranches();
            fetchFestivals();
            setLoadedPage(true);
        }
        if (selectedUser) {
            if (!isAddMode) {
                props.setSmallPageTitle(selectedUser.UserName);
            } else {
                props.setSmallPageTitle('New user');
            }
        } else {
            props.setSmallPageTitle('');
        }
    }, [selectedUser, isAddMode]);

    return (
        <StyledUserAndRules>
            <UserAndRulesLeftPane gridColumns={gridColumns} gridData={gridData} selectedUser={selectedUser} userIdToSelect={selectedUserId} onSelectGridItem={(item) => onSelectGridItem(item)} isAddMode={isAddMode} setIsAddMode={(mode) => {setIsAddMode(mode)}} refreshUsersCallback={fetchUsers} gridStyle={{width:300, height:470}}></UserAndRulesLeftPane>
            {loadedPage===true && (selectedUser || isAddMode) && <UserAndRulesRightPane users={users} selectedUser={selectedUser} isAddUserMode={isAddMode} setIsAddUserMode={(mode) => {setIsAddMode(mode)}} refreshUsersCallback={fetchUsers} branches={branches} festivals={festivals}></UserAndRulesRightPane>}
        </StyledUserAndRules>
    )
}

export default UserAndRules;